import React from 'react';
import { useNavigate } from 'react-router-dom';
// react bootstrap
import Card from 'react-bootstrap/Card';
import ProgressBar from 'react-bootstrap/ProgressBar';
// helper
import { getReadingProgress } from '../../utils/helpers';
// styles
import { Wrapper } from './BookItem.styles';
// image
import NoImage from '../../images/book_place_holder.svg';

const Book = ({ book, source }) => {
  const { title, authors, thumbnail } = book;

  const navigate = useNavigate();

  const openDetailsPage = () => {
    navigate(`/books/${book._id}`, { state: { book, source } });
  };

  return (
    <Wrapper>
      <Card border='light' className={'text-start card'}>
        <Card.Img
          variant='top'
          src={thumbnail ? thumbnail : NoImage}
          onClick={() => openDetailsPage()}
        />
        <Card.Body>
          <Card.Title className={'book-title'}>
            {title && (title.length < 25 ? title : `${title.slice(0, 25)} ...`)}
          </Card.Title>
          <Card.Subtitle className={'book-author'}>
            {authors[0] || 'N/A'}
          </Card.Subtitle>
          {source === 'reading' && (
            <ProgressBar
              className='mt-2'
              now={getReadingProgress(book.currentPage, book.totalPages)}
              label={`${getReadingProgress(
                book.currentPage,
                book.totalPages
              )}%`}
            />
          )}
        </Card.Body>
      </Card>
    </Wrapper>
  );
};

export default Book;
